var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_2_11731)" } }, [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M0.883642 22.0977C0.23726 23.3024 0.135475 24.2447 0.491815 24.899C0.801019 25.4667 1.47796 25.8631 2.5527 26.0304C3.62137 26.1967 5.02095 26.1246 6.66442 25.8158C9.94756 25.1989 14.1285 23.6524 18.4206 21.3146C22.7128 18.9769 26.2799 16.3034 28.579 13.8798C29.7299 12.6666 30.5497 11.53 30.9896 10.5419C31.432 9.54831 31.4662 8.76459 31.157 8.19688C30.8321 7.60036 30.1004 7.19311 28.9324 7.04219C27.7731 6.89239 26.2548 7.00677 24.4809 7.38047L24.3451 6.73562C26.1566 6.354 27.7556 6.22565 29.0169 6.38862C30.2694 6.55046 31.2618 7.01149 31.7357 7.88167C32.187 8.71016 32.0713 9.73272 31.5916 10.81C31.1095 11.8929 30.2349 13.0918 29.0571 14.3333C26.6989 16.8192 23.0715 19.5319 18.7358 21.8933C14.4002 24.2548 10.1537 25.8307 6.78611 26.4635C5.10422 26.7795 3.62262 26.8639 2.45133 26.6815C1.28612 26.5002 0.36433 26.0427 -0.0869149 25.2142C-0.605886 24.2613 -0.376964 23.0533 0.302945 21.7861C0.989834 20.5059 2.1791 19.0808 3.74634 17.6215L4.19543 18.1038C2.65566 19.5376 1.52304 20.906 0.883642 22.0977Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M22.6392 1.64961L22.6392 -2.88059e-08L23.2982 0L23.2982 1.64961L22.6392 1.64961Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M22.6392 3.95585L22.6392 2.30624L23.2982 2.30624L23.2982 3.95585L22.6392 3.95585Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M23.2955 1.64724L24.9451 1.64724L24.9451 2.30624L23.2955 2.30624L23.2955 1.64724Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M20.9924 1.64724L22.642 1.64724L22.642 2.30624L20.9924 2.30624L20.9924 1.64724Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M0.895287 8.56627L0.895287 6.58926L1.55429 6.58926L1.55429 8.56627L0.895287 8.56627Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M0.895287 11.2022L0.895287 9.22519L1.55429 9.22519L1.55429 11.2022L0.895287 11.2022Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M1.5554 8.56619L3.53241 8.56619L3.53241 9.22519L1.5554 9.22519L1.5554 8.56619Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M-1.08208 8.56619L0.894928 8.56619L0.894928 9.22519L-1.08208 9.22519L-1.08208 8.56619Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M29.2338 19.7644L29.2338 18.452L29.8928 18.452L29.8928 19.7644L29.2338 19.7644Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M29.2338 21.7409L29.2338 20.4285L29.8928 20.4285L29.8928 21.7409L29.2338 21.7409Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M29.8929 19.7695L31.2053 19.7695L31.2053 20.4285L29.8929 20.4285L29.8929 19.7695Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M27.9163 19.7695L29.2287 19.7695L29.2287 20.4285L27.9163 20.4285L27.9163 19.7695Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: { d: "M13.4166 0L14.7346 0V1.31801H13.4166V0Z", fill: "white" }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M25.9385 10.5438H27.2565V11.8618H25.9385V10.5438Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M3.53223 21.7469H4.85023V23.0649H3.53223V21.7469Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M10.7807 3.95312H11.4397V4.61213H10.7807V3.95312Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M20.1561 6.52755L20.5861 8.13231L5.40867 12.1991L4.97867 10.5943L6.60373 6.37495L12.8638 9.16951L16.4732 3.73043L20.1561 6.52755Z",
            fill: "#E1503C"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M7.30753 8.70685L6.65543 10.1584L7.25656 10.4285L7.65855 9.53364L10.4756 10.5478L10.6988 9.92779L7.30753 8.70685Z",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M16.8487 6.15136L18.1392 7.08242L17.7536 7.61685L16.9581 7.04289L15.0256 9.32971L14.5222 8.90435L16.8487 6.15136Z",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M4.79373 12.2832L21.7568 7.73796L26.302 24.701L9.33897 29.2463L4.79373 12.2832Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M3.60312 12.602L22.947 7.41879L23.8241 10.6924L4.48027 15.8755L3.60312 12.602Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M10.4473 10.7691L13.4232 9.97172L14.3004 13.2453L11.3244 14.0427L10.4473 10.7691Z",
            fill: "#E1503C"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M12.2176 13.8035L15.1936 13.0061L18.8617 26.6956L15.8857 27.493L12.2176 13.8035Z",
            fill: "#E1503C"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M21.8203 11.5483L6.64282 15.6151L6.47226 14.9785L21.6497 10.9117L21.8203 11.5483Z",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M10.841 7.47385L13.5194 6.75618L14.3168 9.73215L11.6384 10.4498L10.841 7.47385Z",
            fill: "#E1503C"
          }
        }),
        _vm._v(" "),
        _c(
          "mask",
          {
            staticStyle: { "mask-type": "alpha" },
            attrs: {
              id: "mask0_2_11731",
              maskUnits: "userSpaceOnUse",
              x: "4",
              y: "7",
              width: "23",
              height: "23"
            }
          },
          [
            _c("path", {
              attrs: {
                d:
                  "M4.79315 12.2824L21.7562 7.73717L26.3015 24.7002L9.33839 29.2455L4.79315 12.2824Z",
                fill: "white"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c("g", { attrs: { mask: "url(#mask0_2_11731)" } }, [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d:
                "M0.883826 22.0973C0.237443 23.302 0.135658 24.2443 0.491998 24.8986C0.801202 25.4663 1.47814 25.8627 2.55288 26.03C3.62155 26.1963 5.02114 26.1242 6.6646 25.8154C9.94775 25.1985 14.1287 23.652 18.4208 21.3142C22.7129 18.9765 26.2801 16.303 28.5792 13.8794C29.7301 12.6662 30.5499 11.5296 30.9898 10.5415C31.4322 9.54791 31.4664 8.76419 31.1572 8.19648C30.8323 7.59996 30.1006 7.19271 28.9326 7.04179C27.7733 6.89199 26.255 7.00637 24.4811 7.38007L24.3452 6.73523C26.1568 6.3536 27.7558 6.22525 29.0171 6.38822C30.2696 6.55006 31.2619 7.01109 31.7359 7.88127C32.1871 8.70976 32.0715 9.73232 31.5918 10.8096C31.1096 11.8925 30.2351 13.0914 29.0573 14.3329C26.699 16.8188 23.0716 19.5315 18.736 21.8929C14.4004 24.2544 10.1539 25.8303 6.78629 26.4631C5.1044 26.7791 3.6228 26.8635 2.45152 26.6812C1.2863 26.4998 0.364513 26.0423 -0.0867318 25.2138C-0.605703 24.2609 -0.37678 23.0529 0.303128 21.7857C0.990018 20.5055 2.17928 19.0804 3.74653 17.6211L4.19561 18.1034C2.65584 19.5372 1.52323 20.9056 0.883826 22.0973Z",
              fill: "black"
            }
          })
        ]),
        _vm._v(" "),
        _c("line", {
          attrs: {
            x1: "9.4613",
            y1: "31.6705",
            x2: "26.5954",
            y2: "31.6705",
            stroke: "black",
            "stroke-width": "0.659003"
          }
        })
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_2_11731" } }, [
          _c("rect", { attrs: { width: "32", height: "32", fill: "white" } })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }